<template>
  <header class="page-header">
    <h1>Mini New API</h1>
    <p>极简大模型 API 中转站，可生成本地 API Key，并按 prompt/completion token 扣减额度。</p>
  </header>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>
